import { ApplicationVote } from "@/api/applicationQueries"

export function convertTimestampToDateTime(
    timestamp: {
        seconds: number | null
        nanoseconds: number | null
    } | null
): string {
    if (!timestamp || timestamp.seconds === null) return "No date available"

    const date = new Date(
        timestamp.seconds * 1000 + (timestamp.nanoseconds || 0) / 1000000
    )
    const dateOptions: Intl.DateTimeFormatOptions = {
        day: "numeric",
        month: "long",
        year: "numeric",
    }
    const timeOptions: Intl.DateTimeFormatOptions = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    }

    return `${date.toLocaleDateString("en-GB", dateOptions)} at ${date.toLocaleTimeString("en-GB", timeOptions)}`
}

export function formatGBP(amount: number) {
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(amount)
}

export function calculateAverageScore(votes: ApplicationVote[]): number {
    if (!votes || votes.length === 0) return 0

    const totalScore = votes.reduce((sum, vote) => sum + vote.score, 0)
    const averageScore = totalScore / votes.length

    return isNaN(averageScore) ? 0 : averageScore
}
